import { useContext } from "react";

import Multimedia from "@sharedComponents/multimedia";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import styles from "./main-taxon-banner.module.scss";

const MainTaxonBanner = ({ item, className = "" }) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const imgSrc = isMobileDevice ? item.mobileBanner : item.banner;
  return (
    <article
      className={`${styles.categoryBannerContainer} ${
        imgSrc ? styles.withBanner : styles.withOutBanner
      } ${className}`}
    >
      <Multimedia
        type="image"
        src={imgSrc}
        className={styles.bannerImg}
        height={137}
        width={1036}
      />

      <div className={styles.catBannername}>{item.name}</div>
    </article>
  );
};

export default MainTaxonBanner;
